import React from 'react';
import { FormattedMessage } from 'react-intl';

const NoDataSupplied = () => <FormattedMessage id={'intl-msg:vehicle-diagnostics.maintenance.table.noDataSupplied'} />;

export default NoDataSupplied;
